import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import RaisedButton from 'material-ui/RaisedButton';
// import FlatButton from 'material-ui/FlatButton';
// import { CardActions, CardText } from 'material-ui/Card';
import LinearProgress from 'material-ui/LinearProgress';
// import Paper from 'material-ui/Paper';
// import Divider from 'material-ui/Divider';
import {
  TextField,
  FontIcon,
  IconButton,
} from 'material-ui';
// import { Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
// import { apiUrl, useSSO, hideXapLogin } from 'config';
import { apiUrl, useSSO, hideXapLogin } from 'utils/settings';
import pallet from 'constants/colors';

import { FormattedMessage } from 'react-intl';

import PanelMessage from 'components/panels/PanelMessage';
import Loading from 'components/Loading';
import KButtonLink from 'components/KJRN/KButtonLink';
import { loginUser, loginStep } from '../../actions/account/login';
import KButton from '../KJRN/KButton';
import KTitle from '../KJRN/KTitle';

const styles = {
  input: {
    marginTop: 0,
  },
  divider: {
    marginTop: 0,
  },
  cardContent: {
    paddingTop: 0,
    paddingRight: 8,
    paddingLeft: 8,
  },
  root: {
    marginTop: 12,
  },
  message: {
    textAlign: 'center',
    padding: 24,
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  sso: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    marginBottom: 16,
  },
  switch: {
    textAlign: 'center',
    marginTop: 32,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  containerSSO: {
    marginTop: '10vh',
    zIndex: 100,
  },
  container: {
    marginTop: '5vh',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 600,
    width: '100%',
    flexWrap: 'wrap',
    zIndex: 100,
  },
  underlineStyle: {
    borderColor: pallet.primaryColor1,
    color: pallet.primaryColor1,
  },
  titleContainer: {
    display: 'flex',
    flex: '1 1 90%',
    alignItems: 'flex-start',
    flexDirection: 'column',
    paddingTop: 10,
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 24px)',
    padding: 12,
  },
  backContainer: {
    flex: 1,
  },
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  setXapLogin = () => this.props.dispatch(loginStep('xap'));
  setSSOLogin = () => this.props.dispatch(loginStep('sso'));
  forgotPassword = () => this.props.dispatch(loginStep('forgotPassword'));
  loginUser = () => {
    const { props: { dispatch }, state: { username, password } } = this;
    dispatch(loginUser(username, encodeURIComponent(password)));
  };


  handleKeyDown = (event) => {
    if (event.key === 'Enter' && event.target.id === 'password') {
      this.password.blur();
      this.loginUser();
    } else if (event.key === 'Enter') {
      this.password.focus();
    }
  };

  handlePasswordChange = ev => this.setState({ password: ev.target.value });
  handleUsernameChange = ev => this.setState({ username: ev.target.value });

  render() {
    const {
      handleUsernameChange,
      handlePasswordChange,
      handleKeyDown,
      state: { username, password },
      props: {
        sso, ssoLoading, validationError, loading, error,
      },
    } = this;

    // TODO: Fix error message when no internet and when cannot connect to kjarni
    const errorMessage = error && error.Message === 'The user name or password is incorrect.' ? <FormattedMessage id="account.wrongPassword" /> : error && error.Message;

    if (ssoLoading) {
      return (<Loading />);
    }

    if (sso) {
      return (
        <div style={styles.containerSSO}>
          <KTitle title={<FormattedMessage id="account.ssoTitle" />} style={{ marginBottom: '5vh' }} />
          <div style={styles.actions}>
            <KButtonLink
              href={`${apiUrl}/api/qdata/route?url=${encodeURIComponent(window.location.origin)}`}
              label={<FormattedMessage id="account.loginWindows" />}
            />
            {!hideXapLogin &&
              <KButton
                onClick={this.setXapLogin}
                flat
                label={<FormattedMessage id="account.loginWithXap" />}
              />
            }
          </div>
        </div>
      );
    }

    return (
      <div style={styles.container}>
        {useSSO &&
          <div style={styles.backContainer}>
            <IconButton onClick={this.setSSOLogin} >
              <FontIcon className="material-icons">arrow_back</FontIcon>
            </IconButton>
          </div>
        }
        <div style={styles.titleContainer}>
          <KTitle title={<FormattedMessage id="account.title" />} />
          <div style={styles.inputContainer}>
            <TextField
              type="text"
              hintText={<FormattedMessage id="account.usernameemail" />}
              style={styles.root}
              inputStyle={styles.input}
              value={username || ''}
              onKeyDown={handleKeyDown}
              onChange={handleUsernameChange}
              underlineFocusStyle={styles.underlineStyle}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              ref={(u) => { this.username = u; }}
              fullWidth
              id="username"
            />
            <TextField
              type="password"
              hintText={<FormattedMessage id="account.password" />}
              style={styles.root}
              inputStyle={styles.input}
              value={password || ''}
              onKeyDown={handleKeyDown}
              onChange={handlePasswordChange}
              underlineFocusStyle={styles.underlineStyle}
              fullWidth
              ref={(p) => { this.password = p; }}
              id="password"
            />
            {!hideXapLogin &&
              <KButton
                flat
                buttonStyle={{ fontSize: 14 }}
                containerStyle={{ height: 32, width: 150, alignSelf: 'flex-end' }}
                label={<FormattedMessage id="account.forgotPassword" />}
                onClick={this.forgotPassword}
                disabled={ssoLoading || loading}
              />
            }
            {loading && <LinearProgress mode="indeterminate" />}
            <KButton
              label={<FormattedMessage id="account.login" />}
              disabled={ssoLoading || loading}
              containerStyle={{ width: 200, alignSelf: 'center', marginTop: '5vh' }}
              onClick={this.loginUser}
            />
            {validationError && validationError.Message &&
              <PanelMessage message={validationError.Message} iconName="warning" type="warning" />
            }
            {error && error.Message &&
              <PanelMessage message={errorMessage} iconName="error" type="error" />
            }
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  validationError: PropTypes.object,
  error: PropTypes.object,
  loading: PropTypes.bool,
  ssoLoading: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  sso: PropTypes.bool,
};

Login.contextTypes = {
  muiTheme: PropTypes.object,
};

function mapStateToProps(state) {
  return { ...state.loginReducer };
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/account/Login.js